/** Google Calendar appointment scheduling (shared: nav + contact). */
export const SCHEDULE_APPOINTMENT_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1eNoHzSiHMNGEnKZjaAI0sjzc_SY-Irieqe8yv8Zru0ps3mxiziBPz_i9a9YVdFn6UE7n43AC2";
